// frontend/src/components/common/LoadingSpinner.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const LoadingSpinner = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A3E0] mx-auto mb-4"></div>
        <p className="text-[#002855]">
          {t({ en: "Loading...", de: "Wird geladen..." })}
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
